__turbopack_context__.v({
  "fullpagewrapper": "ppb7Wa_fullpagewrapper",
});
